import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.function.name.js";
import { i18n } from '@/boot/i18n';
/**
 * Build a FIBQuizScreen model
 *
 * @param {Object} context context
 * @param {Array} questions The array of FC question components which comprise the screen
 * @param {Object} meta Any other metadata to provide in every question's _meta element to link back.
 *
 * @returns {Object} FIBQuizScreen model
 */

export function makeScreen(context, questions) {
  var _questions, _questions$, _questions$$_meta, _questions$$_meta$que, _questions2, _questions2$, _questions2$$_meta;

  var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var section = context.section; // only add screen if questions present

  if (!Array.isArray(questions) || !questions.length) {
    return null;
  }

  questions = questions.map(function (q) {
    // Extend any existing question._meta with that passed and the section.
    q._meta = _objectSpread(_objectSpread(_objectSpread({}, q._meta || {}), meta), {}, {
      section: section
    });
    return q;
  });
  var required = section.name === 'questions' ? meta.question.required : section.required;
  var titleKey = 'questions.' + section.name + '.title';
  var titleFromKey = i18n.te(titleKey) ? i18n.t(titleKey) : '';
  return {
    title: meta.title || titleFromKey,
    // prefer meta title
    userCanSkip: !required,
    questions: questions,
    section: section,
    questionId: (_questions = questions) === null || _questions === void 0 ? void 0 : (_questions$ = _questions[0]) === null || _questions$ === void 0 ? void 0 : (_questions$$_meta = _questions$._meta) === null || _questions$$_meta === void 0 ? void 0 : (_questions$$_meta$que = _questions$$_meta.question) === null || _questions$$_meta$que === void 0 ? void 0 : _questions$$_meta$que.id,
    question: (_questions2 = questions) === null || _questions2 === void 0 ? void 0 : (_questions2$ = _questions2[0]) === null || _questions2$ === void 0 ? void 0 : (_questions2$$_meta = _questions2$._meta) === null || _questions2$$_meta === void 0 ? void 0 : _questions2$$_meta.question
  };
}
/**
 * Build a FIBQuizScreen model from a survey question
 *
 * @param {Object} context context
 * @param {Array} questions The array of FC question components which comprise the screen
 * @param {Object} meta Any other metadata to provide in every question's _meta element to link back.
 *
 * @returns {Object} FIBQuizScreen model
 */

export function makeQuestionScreen(context, questions, surveyQuestion) {
  var meta = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return makeScreen(context, questions, _objectSpread({
    question: surveyQuestion
  }, meta));
}
/**
 * Append a question answer to a mutated submit
 *
 * @param {Object} submit submit
 * @param {Object} response response
 * @param {Object} answer answer
 */

export function addSubmitQuestion(submit, response, answer) {
  submit.questions = submit.questions || [];
  submit.questions.push({
    id: response.question.id,
    answer: answer
  });
}